<template>
  <v-sheet class="py-2 px-5">
    <VehiclesField v-model="vehicles" />
    <PeriodField v-model="period" :periods="periods" />
  </v-sheet>
</template>

<script>
import PeriodField from "@/components/fields/PeriodField";
import VehiclesField from "@/components/fields/VehiclesField.vue";

export default {
  name: "CountriesSummaryReport",
  components: { VehiclesField, PeriodField },

  data() {
    return {
      periods: [
        { name: "month-current" },
        { name: "month-previous" },
        { name: "month-one" },
        { name: "month-range" },
        { name: "day-range" }
      ],
      enableFetch: false,

      vehicles: null,
      period: null
    };
  },

  methods: {
    fetchReport() {
      if (this.enableFetch && this.period !== null)
        this.$store.dispatch("report/fetch", {
          name: "countries-summary",
          period: this.period,
          vehicles: this.vehicles,
          groupset: this.$store.getters["groupsets/getGroupsetId"],
          output: "pdf",
          download: false
        })
          .then(response => {
            this.$emit("pdf", response.data);
          });
    },

    downloadReport(output) {
      if (this.period !== null)
        this.$store.dispatch("report/fetch", {
          name: "countries-summary",
          period: this.period,
          vehicles: this.vehicles,
          groupset: this.$store.getters["groupsets/getGroupsetId"],
          output: output,
          download: true
        });
    },

    updateUrl() {
      this.$router.replace({
        name: "report/countries-summary", query: {
          ...this.$route.query,
          vehicleIds: (this.vehicles !== null && this.vehicles.length > 0) ? this.vehicles.map(x => x.vehicleId.toString()).join(",") : undefined,
          period: this.$router.periodToQuery(this.period)
        }
      }).catch(() => {
      });
    }
  },

  watch: {
    vehicles: function() {
      this.fetchReport();
      this.$store.dispatch("report/setValue", { name: "vehicleIds", value: this.vehicles });
      this.updateUrl();
    },

    period: function() {
      this.fetchReport();
      this.$store.dispatch("report/setValue", { name: "period", value: this.period });
      this.updateUrl();
    },

    "$store.state.groupsets.groupset": function() {
      this.fetchReport();
    }
  },

  mounted() {
    this.$emit("report",
      {
        name: "countries-summary",
        download: this.downloadReport
      }
    );

    this.vehicles = this.$router.parseQueryVehicleIds(this.$route) || this.$store.state.report.values.vehicleIds || null;
    this.period = this.$router.parseQueryPeriod(this.$route) || this.$store.state.report.values.period || null;

    setTimeout(() => {
      this.enableFetch = true;
      this.fetchReport();
    }, 1);
  }
};
</script>

<style scoped>

</style>